import axiosIns from '@/api/axios'

export const GET_TRAINING_METHOD = (args) => {
    return axiosIns.get('/master-data/training-method', args)
}

